import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { InventoryItemModal } from '../../components';
import { getCategoryPath } from '../../utils/urlPaths';

const getIdFromItemSlug = (slug = '') => {
    const match = slug.match(/-(\d+)$/);
    return match ? match[1] : '';
};

const InventoryModalRoute = () => {
    const { id, itemSlug } = useParams();
    const [item, setItem] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const itemId = id || getIdFromItemSlug(itemSlug);

        if (!itemId) {
            setItem(null);
            return;
        }

        fetch(`https://www.oldhouseparts.com/getInventoryItem.php?id=${itemId}`)
            .then(response => response.json())
            .then(data => setItem(data))
            .catch(error => console.error('Error fetching item:', error));
    }, [id, itemSlug]);

    const handleClose = () => {
        if (location.state?.previousLocation) {
            navigate(-1);
            return;
        }

        if (item?.category && item?.sub_category) {
            navigate(getCategoryPath(item.category, item.sub_category));
            return;
        }

        navigate('/inventory');
    };

    return (
        <>
            {item?.id && (
                <InventoryItemModal 
                    show={true} 
                    onHide={handleClose} 
                    item={item} 
                />
            )}
        </>
    );
};

export default InventoryModalRoute;
